/**
 * Design tokens for the redesigned product catalogue pages (subcategory
 * listing). Kept separate from productTheme.js so the older Product
 * Detail / Category pages that import those tokens are unaffected.
 */
export const CT = {
  navy: "#0B2148",
  darkNavy: "#081A3A",
  blue: "#2563EB",
  blueDark: "#1D4ED8",
  lightBlue: "#EFF6FF",
  bg: "#F8FAFC",
  white: "#FFFFFF",
  border: "#E5E7EB",
  text: "#14213D",
  muted: "#64748B",
};

/** Catalogue container: capped at 1440px (spec: 1280–1440), centred, responsive gutters. */
export const CAT_WRAP = "max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8";
